<script>
  import Layout from '@layouts/main'
  import BookingBanner from '@components/BookingBanner'

  import { authComputed } from '@state/helpers'
  import ModalLogin from '@components/ModalLogin';

  export default {
    page() {
      return {
        title: this.merchant.name,
      }
    },
    components: { Layout, BookingBanner, ModalLogin },
    props: {
      merchant: {
        type: Object,
        required: true,
      },
      prepaids: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        isModalLoginActive: false,
        checkoutProcessing: false,
        loginCallBack: null,
        defaultImage: require('@assets/images/activity_default.png'),
      }
    },
    computed: {
      ...authComputed,
    },
    methods: {
      handleToPrepaidItem(prepaid) {
        this.$router.push({
          name: 'booking-prepaid-item',
          params: {prepaidAlias: prepaid.alias},
          query: {
            language: this.$route.query.language,
          }
        })
      },
      handleToPrepaidCheckout(prepaid) {
        if(!this.loggedIn) {
          this.isModalLoginActive = true;
          this.loginCallBack = () => {
            this.handleToPrepaidCheckout(prepaid)
          };
          return false;
        }

        this.checkoutProcessing = true;

        const cart = {
          ...prepaid
        };

        const sessionCart = {
          merchantAlias: this.merchant.alias,
          prepaidAlias: prepaid.alias
        };
        this.$store.dispatch('booking/updateSessionCart', sessionCart)
          .then(() => {
            this.$store.dispatch('booking/updatePrepaidCart', cart);
            this.$router.push({
              name: 'booking-prepaid-checkout',
              params: {prepaidAlias: prepaid.alias},
              query: {
                language: this.$route.query.language,
              }
            })
          })
          .finally(() => {this.checkoutProcessing = false});
      },
      canBuy(prepaid) {
        return prepaid.infinity || prepaid.qty < prepaid.inventory
      }
    }
  }
</script>
<template>
 <Layout>
   <div class="booking-container">
     <BookingBanner :merchant="merchant"/>
     <template v-if="prepaids.length > 0">
       <div class="booking-section">
         <div class="level subsection is-small">
           <h4
             class="booking-section__title"
           >{{ $t('global.SELECT_PREPAID'/*選擇預付方案*/) }}</h4>
         </div>
         <div v-for="(prepaidItem, index) in prepaids" :key="index" :class="$style.wrapper" @click="handleToPrepaidItem(prepaidItem)">
           <div :class="$style.inner">
             <div class="columns is-multiline is-mobile">
               <div class="column is-full-mobile is-one-third-tablet has-text-centered">
                 <picture>
                   <BaseImage
                     :src="prepaidItem.introimage"
                     :error-src="defaultImage"
                     :class="$style.image"
                     class-name="is-cover"
                   />
                 </picture>
               </div>
               <div :class="$style.content" class="column is-full-mobile">
                 <div>
                   <div :class="$style['name']">{{ prepaidItem.name }}</div>
                   <div>{{prepaidItem.introtext}}</div>
                 </div>
                 <div :class="$style['buttons']" class="level">
                   <div class="level-left" style="position: relative">
                     <span :class="$style['basePrice']" class="has-text-grey-light">${{prepaidItem.basePrice}}</span>
                     <span class="is-size-4 has-text-primary">${{prepaidItem.price}}</span>
                     <span class="is-size-6 has-text-grey-light">・{{ $t('global.USE_DEDUCT_NUMBER', { size: prepaidItem.times  }/*{size}次使用額度*/)}}</span>
                   </div>
                   <div class="level-right">
                     <template>
                       <b-button
                         v-if="canBuy(prepaidItem)"
                         rounded
                         outlined
                         type="is-primary"
                         class="is-mobile-fullwidth fix-width-167"
                         @click.stop.prevent="handleToPrepaidCheckout(prepaidItem)"
                       >
                         {{ $t('global.BUY_NOW'/*立即購買*/) }}
                       </b-button>
                       <b-button
                         v-else
                         rounded
                         outlined
                         type="is-static"
                         class="is-mobile-fullwidth fix-width-167"
                       >
                         {{ $t(`product.prepaid.BUTTON_SOLD_OUT` /* 已售完 */) }}
                       </b-button>
                     </template>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
     </template>
     <template v-else>
       <div class="defaultBox">
         <img :alt="$t('global.NULL_MERCHANT_PREPAID'/*商家無任何預付方案*/)"
              class="defaultBox__image"
              src="@assets/images/information_default.png" />
         <h3 class="defaultBox__text">
           {{ $t('global.NULL_MERCHANT_PREPAID'/*商家無任何預付方案*/) }}
         </h3>
       </div>
     </template>
   </div>
   <b-modal
     custom-class="is-login-style"
     :active.sync="isModalLoginActive"
     :width="370"
     :can-cancel="['escape','outside']">
     <ModalLogin @close="isModalLoginActive = false" @login="loginCallBack"/>
   </b-modal>
 </Layout>
</template>
<style lang="scss" module>
  .wrapper {
    &:hover {
      cursor: pointer;
      transition: box-shadow 0.3s;
      box-shadow: 0 0 15px 0 rgba(178, 180, 181, 0.3);
      .name {
        color: $color-primary;
      }
    }
    + .wrapper .inner {
      border-top: 1px solid $color-border-base;
    }
  }
  .inner {
    padding: 1rem;
    @include desktop {
      padding: 1rem 0 0.9rem;
      margin: 0 1.5rem;
    }
    .content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
  .image {
    height: 162px;
    width: 262px;
    overflow: hidden;
    background: $grey-lighter no-repeat;
    border-radius: $size-image-border-radius;
    cursor: pointer;
    position: relative;
    background-size: cover;
    .icon {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: white;
      height: 2em;
      width: 2em;
    }
  }
  .name {
    font-size: 1.3rem;
    margin-bottom: 0.5rem;
    line-height: 1.2em;
    //@extend %typography-medium;
    font-weight: 500;
    color: $color-heading-text;
    cursor: pointer;
  }
  .basePrice {
    position: absolute;
    top: -26px;
    left: 0;
    text-decoration: line-through;
    font-size: 16px;
  }

  .loading {
    max-width: 360px;
  }
  .buttons {
    padding-bottom: 5px;
    align-items: flex-end;
    @include mobile {
      margin-top: 15px;
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      padding-top: 2rem;
    }
  }
</style>
